import * as Cesium from "cesium";

export class MousePosition {
  constructor(viewer) {
    // 监听鼠标的移动事件
    const handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
    handler.setInputAction((movement) => {
      // 获取鼠标坐标
      const cartesian = viewer.scene.camera.pickEllipsoid(
        movement.endPosition,
        viewer.scene.globe.ellipsoid
      );
      if (cartesian) {
        // 转换为经纬度
        const cartographic = Cesium.Cartographic.fromCartesian(cartesian);
        const longitudeString = Cesium.Math.toDegrees(
          cartographic.longitude
        ).toFixed(2);
        const latitudeString = Cesium.Math.toDegrees(
          cartographic.latitude
        ).toFixed(2);
        const heightString = cartographic.height.toFixed(2);
        const positionString = `经度:${longitudeString} 纬度:${latitudeString} 高度:${heightString}`;
        const dom = document.getElementById("mouse-position");
        if (dom) dom.innerHTML = positionString;
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
  }
}
